import styled from '@emotion/styled';
import { Text } from '@naf/text';
import { spacing } from '@naf/theme';
import { Grid } from '@naf/grid';
import { UserInteraction } from '@naf/user-interaction';

export { SectionHeader as StyledSectionHeader } from '@components/SectionHeader/SectionHeader';

export const Wrapper = styled.div`
  .threeColumnBlock {
    h2 {
      margin-top: ${spacing.space64};
    }
    h3 {
      font-size: 1.25rem;
    }
  }
`;

export const ContentHeader = styled(Text)`
  margin-top: ${spacing.space64};
`;

export const StyledUserInteraction = styled(UserInteraction)`
  margin-top: ${spacing.space64};
`;

export const TopicWrapper = styled(Grid)`
  grid-gap: 0 ${spacing.space32};
  max-width: 1024px;
  justify-content: space-between;
  margin-bottom: ${spacing.space80};
`;
